/** Tab Sharing Method */
export const ECC_SHARE_METHOD = 'ecc';
export const FIELD_SHARE_METHOD = 'field';

export type TabSharingMethod =
  | typeof ECC_SHARE_METHOD
  | typeof FIELD_SHARE_METHOD;

/** Field Sharing */
export const FIELD_DIRECT_RECIPIENTS_SHARE = 'direct-recipients';
export const FIELD_SHARE_LINK_SHARE = 'share-link';

export type FieldSharingMethod =
  | typeof FIELD_DIRECT_RECIPIENTS_SHARE
  | typeof FIELD_SHARE_LINK_SHARE;
